export default "__VITE_ASSET__6RZbpjei__"